import { featuredArticles } from "../../mocks/news";
import { usePageMeta, useJsonLd } from "../../hooks/useSeo";
import Hero from "./components/Hero";
import CategoryStrip from "./components/CategoryStrip";
import LatestFeed from "./components/LatestFeed";
import ExclusiveBand from "./components/ExclusiveBand";
import FeaturedGrid from "./components/FeaturedGrid";
import AboutBand from "./components/AboutBand";

export default function Home() {
  usePageMeta({
    title: "每日爆料网 - 每日爆料独家猛料第一手，娱乐圈网红圈独家曝光首发",
    description:
      "每日爆料网专注独家猛料首发，第一时间聚焦娱乐圈与网红圈热点，第一手内幕与独家曝光快人一步，满足你对独家猛料、八卦热点与行业深挖的所有好奇。",
    keywords: "每日爆料,每日爆料独家,每日爆料首发,每日爆料独家猛料,每日爆料第一手,娱乐圈八卦,网红圈热点",
  });

  useJsonLd("website", {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "每日爆料网",
    url: "https://29nx.cn/",
    inLanguage: "zh-CN",
    description:
      "每日爆料网专注娱乐圈、网红圈独家猛料首发，第一手内幕与深度追踪。",
    publisher: {
      "@type": "Organization",
      name: "每日爆料网",
    },
  });

  useJsonLd("home-itemlist", {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "每日爆料网精选内容",
    itemListElement: featuredArticles.map((a, i) => ({
      "@type": "ListItem",
      position: i + 1,
      url: `https://29nx.cn/news/${a.slug}`,
      name: a.title,
    })),
  });

  return (
    <>
      <h1 className="sr-only">每日爆料网 - 娱乐圈与网红圈独家猛料首发平台</h1>
      <Hero />
      <CategoryStrip />
      <LatestFeed />
      <ExclusiveBand />
      <FeaturedGrid />
      <AboutBand />
    </>
  );
}